module.exports = __webpack_public_path__ + "static/media/msfes_header.6d19b584.png";